import e from"@babel/runtime-corejs3/helpers/esm/extends";import*as r from"react";import{ContainerPortal as o}from"./ContainerPortal.js";function t(t){return r.createElement(o,e({},t,{containerNode:document.body}))}export{t as Portal};
